import * as actionTypes from './authActionTypes';
import { firstCharUpperCase } from "../../Helpers/stringHelpers";
import * as roles from '../../AppData/roles';

const initialState = {
    loggedIn: false,
    userID: 0,
    username: "",
    languageCode: "en-US",
    roles: [],
    isAdmin: false
}

export default function authReducer(state = initialState, action) {
    switch (action.type) {
        case (actionTypes.LOGIN):
            if (state.username !== action.username) {
                let isAdmin = false;
                if (action.roles && action.roles.includes(roles.ADMIN_ROLE)) { isAdmin = true; }

                return Object.assign({}, state, { 
                    loggedIn: true, 
                    userID: action.userID,
                    username: firstCharUpperCase(action.username), 
                    languageCode: action.languageCode, 
                    roles: action.roles,
                    isAdmin: isAdmin 
                });
            }
            return state;
        case (actionTypes.LOGOUT):
            if (state.loggedIn === true) {
                return Object.assign({}, state, { loggedIn: false, username: "", languageCode: "en-US", roles: [] });
            }
            return state;
        default:
            return state;
    }
}


